/** UA/EN strings for project routes: /p/:slug/... (groups, details, project login). */

export function getProjectLoginLocale(lang) {
  return PROJECT_LOGIN[lang] || PROJECT_LOGIN.en;
}

export function getGroupsPageLocale(lang) {
  return GROUPS_PAGE[lang] || GROUPS_PAGE.en;
}

export function getMoreDetailsLocale(lang) {
  return MORE_DETAILS[lang] || MORE_DETAILS.en;
}

export function getDrawerAppBarLocale(lang) {
  return DRAWER_BAR[lang] || DRAWER_BAR.en;
}

const DRAWER_BAR = {
  uk: {
    languageLabelUk: 'UA',
    languageLabelEn: 'EN',
    tabOverview: 'Огляд',
    tabSets: 'Набори',
    tabGroups: 'Групи',
    tabUsers: 'Користувачі',
    tabAdmins: 'Адміністратори',
    myGroupsTab: 'Мої групи',
    adminUsers: 'Користувачі',
    adminGroups: 'Групи',
    adminSets: 'Набори',
    adminStations: 'Станції',
    trendChart: (name) => `Графік роботи: ${name}`,
    trendChartShort: 'Графік роботи',
    openCharts: 'Відкрити графіки',
    alarmHistory: 'Історія аварій',
    refreshData: 'Оновити дані',
    fullscreen: 'Повний екран',
    home: 'На головну',
    refresh: 'Оновити',
    svgRuntime: 'SVG Runtime',
    menuHome: 'Головна',
    menuGroups: 'Групи',
    actions: 'Дії',
    logout: 'Вийти',
    userFallback: 'Користувач',
    roleSuperadminLong: 'Суперадміністратор',
    roleAdminLong: 'Адміністратор',
    roleUserLong: 'Користувач',
    brandScada: 'SCADA',
    sysAdminTitle: 'Системний адміністратор',
    projectAllEvents: 'Проєкт (усі події)',
    stationLoading: 'Завантаження…',
    stationWithUid: (num, uidName) => `Станція ${num} (${uidName})`,
    stationOnly: (num) => `Станція ${num}`,
    uidProjectSettings: 'Налаштування UID / проєктів',
    myGroups: 'Мої групи',
    noProjects: 'Немає проєктів',
    refreshProjectList: 'Оновити список проєктів',
  },
  en: {
    languageLabelUk: 'UA',
    languageLabelEn: 'EN',
    tabOverview: 'Overview',
    tabSets: 'Sets',
    tabGroups: 'Groups',
    tabUsers: 'Users',
    tabAdmins: 'Administrators',
    myGroupsTab: 'My groups',
    adminUsers: 'Users',
    adminGroups: 'Groups',
    adminSets: 'Sets',
    adminStations: 'Stations',
    trendChart: (name) => `Schedule: ${name}`,
    trendChartShort: 'Schedule',
    openCharts: 'Open charts',
    alarmHistory: 'Alarm history',
    refreshData: 'Refresh data',
    fullscreen: 'Fullscreen',
    home: 'Home',
    refresh: 'Refresh',
    svgRuntime: 'SVG Runtime',
    menuHome: 'Home',
    menuGroups: 'Groups',
    actions: 'Actions',
    logout: 'Log out',
    userFallback: 'User',
    roleSuperadminLong: 'Super administrator',
    roleAdminLong: 'Administrator',
    roleUserLong: 'User',
    brandScada: 'SCADA',
    sysAdminTitle: 'System administrator',
    projectAllEvents: 'Project (all events)',
    stationLoading: 'Loading…',
    stationWithUid: (num, uidName) => `Station ${num} (${uidName})`,
    stationOnly: (num) => `Station ${num}`,
    uidProjectSettings: 'UID / project settings',
    myGroups: 'My groups',
    noProjects: 'No projects',
    refreshProjectList: 'Refresh project list',
  },
};

const PROJECT_LOGIN = {
  uk: {
    languageLabelUk: 'UA',
    languageLabelEn: 'EN',
    title: 'Вхід у проєкт',
    checkingProject: 'Перевірка проєкту…',
    projectMissingHint: '(такого проєкту не існує — зверніться до постачальника послуг)',
    username: 'Імʼя користувача',
    password: 'Пароль',
    rememberMe: 'Запамʼятати мене',
    signIn: 'Увійти',
    errorLogin: 'Помилка входу',
    badCredentials: 'Невірні облікові дані',
    badUserPass: 'Невірний логін або пароль',
    noProjectSpecified: 'Проєкт не вказано',
    openV2Login: 'Вхід USCADA (V2) / суперадмін',
    signOutToV2: 'Вийти й відкрити V2-вхід',
    logout: 'Вийти',
  },
  en: {
    languageLabelUk: 'UA',
    languageLabelEn: 'EN',
    title: 'Project sign-in',
    checkingProject: 'Checking project…',
    projectMissingHint: '(this project does not exist — contact your service provider)',
    username: 'Username',
    password: 'Password',
    rememberMe: 'Remember me',
    signIn: 'Sign in',
    errorLogin: 'Sign-in error',
    badCredentials: 'Invalid credentials',
    badUserPass: 'Invalid username or password',
    noProjectSpecified: 'Project not specified',
    openV2Login: 'USCADA (V2) / superadmin sign-in',
    signOutToV2: 'Sign out and open V2 login',
    logout: 'Log out',
  },
};

const GROUPS_PAGE = {
  uk: {
    languageLabelUk: 'UA',
    languageLabelEn: 'EN',
    loadError: 'Помилка завантаження даних',
    noStationsInGroup: 'Немає станцій у групі',
    listComponentNotConfigured: 'Компонент списку не налаштовано',
    noSetsInGroup: 'Немає наборів у групі',
    unnamed: 'Без назви',
    stationPrefix: 'Станція',
    stationDataUnavailable: 'дані недоступні',
    stationLoading: 'завантаження…',
    noStationsInSet: 'Немає станцій у наборі',
    selectGroupViaMenu: 'Оберіть групу через меню',
    noCardsInGroup: 'Немає карток у групі',
    mapModeCards: 'Картки',
    mapModeMap: 'Мапа',
    mapProviderLabel: 'Підкладка мапи',
    noCardsWithMapCoords: 'Немає карток із координатами для відображення на мапі',
  },
  en: {
    languageLabelUk: 'UA',
    languageLabelEn: 'EN',
    loadError: 'Failed to load data',
    noStationsInGroup: 'No stations in this group',
    listComponentNotConfigured: 'List component is not configured',
    noSetsInGroup: 'No sets in this group',
    unnamed: 'Unnamed',
    stationPrefix: 'Station',
    stationDataUnavailable: 'data unavailable',
    stationLoading: 'loading…',
    noStationsInSet: 'No stations in this set',
    selectGroupViaMenu: 'Select a group from the menu',
    noCardsInGroup: 'No cards in this group',
    mapModeCards: 'Cards',
    mapModeMap: 'Map',
    mapProviderLabel: 'Map provider',
    noCardsWithMapCoords: 'No cards with map coordinates to display',
  },
};

const MORE_DETAILS = {
  uk: {
    languageLabelUk: 'UA',
    languageLabelEn: 'EN',
    cardNotFound: (name) => `Картку «${name}» не знайдено`,
    resolveCardFailed: 'Не вдалося розвʼязати картку',
    loadError: 'Помилка завантаження',
    svgNeedContext:
      'Для SVG відкрийте екран із групи/набору карток (потрібен контекст UID+станція) або задайте ціль',
    svgTargetHint: 'svg:<uid-uuid>:<id>',
    back: 'Назад',
    ariaLoadingProjectCard: 'Завантаження проєктної картки',
    ariaLoadingStation: 'Завантаження даних станції',
    stationNotFound: 'Станцію не знайдено',
    uidMissingLine: (ps, uc) =>
      `UID не знайдено (projectSlug: ${ps || 'немає'}, uidCode: ${uc || 'немає'})`,
    noPumpRights: 'У вас немає прав на керування',
    commandSendFailed: 'Помилка надсилання команди',
    commandOfflineDisabled: 'Станція офлайн, керування недоступне',
    statusNoAlarms: 'АВАРІЙ НЕМАЄ',
    alarmsTitle: (n) => `АВАРІЇ (${n})`,
    alarmNoDescription: 'Аварія без опису',
    warningsTitle: (n) => `ПОПЕРЕДЖЕННЯ (${n})`,
    warningTitleOne: 'ПОПЕРЕДЖЕННЯ',
    warningNoDescription: 'Попередження без опису',
    eventHistory: 'ІСТОРІЯ ПОДІЙ:',
    noTime: 'Немає часу',
    eventNoDescription: 'Подія без опису',
    noEvents: 'Події відсутні',
    openCharts: 'Відкрити графіки',
    speedDialAria: 'Швидкі дії',
    tooltipTrends: 'Відкрити тренди',
    tooltipAlarms: 'Історія аварій',
    tooltipRefresh: 'Оновити дані',
    tooltipFullscreen: 'Повноекранний режим',
    stationPrefix: 'Станція',
    detailPanelsLabel: 'Показати:',
    panelSvg: 'SVG',
    panelCard: 'Картка',
    panelAlarms: 'Аварії',
    panelTrends: 'Графіки',
    numpad: {
      titleDefault: 'Введіть значення',
      placeholder: '0',
      confirm: 'Підтвердити',
      cancel: 'Скасувати',
      chooseParameter: 'Оберіть параметр:',
      rangeLine: (lo, hi, extra) =>
        `Ліміт у калькуляторі: ${lo} … ${hi}${extra}`,
      rangeScaleNoClamp: (lo, hi, extra) =>
        `Без ліміту · орієнтир SCADA ${lo}…${hi}${extra}`,
      rangeScaleNoClampUnknown: (extra) =>
        `Без ліміту · масштаб за тегом${extra}`,
      suffixInteger: ' (ціле)',
      suffixPrecision: (p) =>
        ` (до ${p} знаків; після масштабування сире PLC має бути цілим)`,
      suffixIntegerRaw: ' (після масштабування сире PLC має бути цілим)',
      rangeServerOnly:
        'Ліміт у калькуляторі увімкнено; межі SCADA в тегу не задані — перевірка на сервері.',
      validationEmpty: 'Введіть значення',
      validationNaN: 'Введіть коректне число',
      validationMin: (m) => `Мінімум: ${m}`,
      validationMax: (m) => `Максимум: ${m}`,
      rangeUnboundedLow: '−∞',
      rangeUnboundedHigh: '+∞',
      errFractionalPlc: (raw, dtype) =>
        `Після масштабування SCADA відповідає дробовому сирому PLC ${raw}; тип «${dtype}» потребує цілого сирого значення.`,
      errPlcOutOfRange: (raw, lo, hi) =>
        `Сире значення PLC ${raw} поза діапазоном ${lo}…${hi}.`,
      errPrefixNonHex:
        'Префікс команди: лише символи 0-9 та A-F.',
      errPrefixOddLength:
        'Префікс команди: кількість hex-символів має бути парною.',
      errNotFinite: 'Значення не є скінченним числом.',
      errPacketOffset:
        'Зміщення в пакеті (packet_offset) має бути від 0 до 65535 (у тілі команди — uint16 BE).',
      errInternalOddHex: 'Внутрішня помилка: непарна довжина hex.',
      errBodyTooLong:
        'Тіло команди занадто довге (більше 512 символів hex).',
      errStringUnsupported:
        'Рядкові теги не підтримуються для числового запису.',
      errBitsliceUnsupported:
        'Бітові зрізи тегів не підтримуються для числового запису.',
      errFailedBuild: 'Не вдалося сформувати числову команду',
    },
  },
  en: {
    languageLabelUk: 'UA',
    languageLabelEn: 'EN',
    cardNotFound: (name) => `Card «${name}» not found`,
    resolveCardFailed: 'Could not resolve card',
    loadError: 'Load error',
    svgNeedContext:
      'For SVG, open this screen from a group or card set (UID + station context required), or set target',
    svgTargetHint: 'svg:<uid-uuid>:<id>',
    back: 'Back',
    ariaLoadingProjectCard: 'Loading project card',
    ariaLoadingStation: 'Loading station data',
    stationNotFound: 'Station not found',
    uidMissingLine: (ps, uc) =>
      `UID not found (projectSlug: ${ps || 'n/a'}, uidCode: ${uc || 'n/a'})`,
    noPumpRights: 'You do not have control permissions',
    commandSendFailed: 'Failed to send command',
    commandOfflineDisabled: 'Station is offline, control is unavailable',
    statusNoAlarms: 'NO ALARMS',
    alarmsTitle: (n) => `ALARMS (${n})`,
    alarmNoDescription: 'Alarm with no description',
    warningsTitle: (n) => `WARNINGS (${n})`,
    warningTitleOne: 'WARNING',
    warningNoDescription: 'Warning with no description',
    eventHistory: 'EVENT HISTORY:',
    noTime: 'No time',
    eventNoDescription: 'Event with no description',
    noEvents: 'No events',
    openCharts: 'Open charts',
    speedDialAria: 'Quick actions',
    tooltipTrends: 'Open trends',
    tooltipAlarms: 'Alarm history',
    tooltipRefresh: 'Refresh data',
    tooltipFullscreen: 'Fullscreen',
    stationPrefix: 'Station',
    detailPanelsLabel: 'Show:',
    panelSvg: 'SVG',
    panelCard: 'Card',
    panelAlarms: 'Alarms',
    panelTrends: 'Charts',
    numpad: {
      titleDefault: 'Enter value',
      placeholder: '0',
      confirm: 'Confirm',
      cancel: 'Cancel',
      chooseParameter: 'Select parameter:',
      rangeLine: (lo, hi, extra) =>
        `Calculator limit: ${lo} … ${hi}${extra}`,
      rangeScaleNoClamp: (lo, hi, extra) =>
        `No limit · SCADA scale ref. ${lo}…${hi}${extra}`,
      rangeScaleNoClampUnknown: (extra) =>
        `No limit · scaled from tag${extra}`,
      suffixInteger: ' (integer)',
      suffixPrecision: (p) =>
        ` (up to ${p} decimal places; scaled PLC raw must be an integer)`,
      suffixIntegerRaw: ' (scaled PLC raw must be an integer)',
      rangeServerOnly:
        'Calculator limit is on but tag SCADA min/max are missing; the server validates the value.',
      validationEmpty: 'Enter a value',
      validationNaN: 'Enter a valid number',
      validationMin: (m) => `Minimum: ${m}`,
      validationMax: (m) => `Maximum: ${m}`,
      rangeUnboundedLow: '−∞',
      rangeUnboundedHigh: '+∞',
      errFractionalPlc: (raw, dtype) =>
        `After scaling, SCADA maps to fractional PLC raw ${raw}; type “${dtype}” requires an integer raw value.`,
      errPlcOutOfRange: (raw, lo, hi) =>
        `PLC raw value ${raw} is outside the range ${lo}…${hi}.`,
      errPrefixNonHex:
        'Command prefix: only 0-9 and A-F hex characters are allowed.',
      errPrefixOddLength:
        'Command prefix: hex length must be even.',
      errNotFinite: 'Value is not a finite number.',
      errPacketOffset:
        'Packet offset (packet_offset) must be between 0 and 65535 (uint16 big-endian in the command body).',
      errInternalOddHex: 'Internal error: odd hex length.',
      errBodyTooLong:
        'Command body is too long (more than 512 hex characters).',
      errStringUnsupported:
        'String tags are not supported for numeric write.',
      errBitsliceUnsupported:
        'Bit-sliced tags are not supported for numeric write.',
      errFailedBuild: 'Failed to build numeric command',
    },
  },
};

export function getTrendsPageLocale(lang) {
  return TRENDS_PAGE[lang] || TRENDS_PAGE.en;
}

export function getTimeRangeLocale(lang) {
  return TIME_RANGE_PAGE[lang] || TIME_RANGE_PAGE.en;
}

export function getAlarmsPageLocale(lang) {
  return ALARMS_PAGE[lang] || ALARMS_PAGE.en;
}

const TRENDS_PAGE = {
  uk: {
    languageLabelUk: 'UA',
    languageLabelEn: 'EN',
    chartSettings: 'Налаштування графіка',
    scopeSourceTitle: 'Об’єкт / джерело (uid, station, projectOnly)',
    uidRouteDefault: '(як у станції в маршруті)',
    projectTags: 'Проєкт (теги проєкту)',
    stationNumLabel: '№ ст.',
    projectTrendsOnly: 'Лише проєктні тренди',
    applyFilter: 'Застосувати фільтр',
    refreshing: 'Оновлення…',
    refresh: 'Оновити',
    toggleLines: 'Показати/приховати лінії:',
    counterHint: 'Витрата за період. Тег має постійно зростати',
    consumptionTitle: 'Витрата',
    bucketHour: 'Година',
    bucketDay: 'Доба',
    uuidError: 'Не вдалося визначити UUID станції. Оновіть сторінку.',
    loadErrorPrefix: 'Помилка завантаження даних трендів:',
    unknownError: 'Невідома помилка',
    loadDataError: 'Помилка завантаження даних:',
    noDataForPeriod: 'Немає даних за обраний період',
    resetZoom: 'Скинути масштаб',
    wheelHint: 'Коліщатко миші — масштаб; перетягування — переміщення',
    fabSettingsAria: 'Налаштування',
    stationTitle: (stationId) => `Станція ${stationId}`,
    docTitle: (stationId) => `Тренди · станція ${stationId}`,
  },
  en: {
    languageLabelUk: 'UA',
    languageLabelEn: 'EN',
    chartSettings: 'Chart settings',
    scopeSourceTitle: 'Object / source (uid, station, projectOnly)',
    uidRouteDefault: '(same as station in route)',
    projectTags: 'Project (project tags)',
    stationNumLabel: 'St. №',
    projectTrendsOnly: 'Project trends only',
    applyFilter: 'Apply filter',
    refreshing: 'Refreshing…',
    refresh: 'Refresh',
    toggleLines: 'Show/hide lines:',
    counterHint: 'Consumption over the period. The tag is a running total',
    consumptionTitle: 'Consumption',
    bucketHour: 'Hour',
    bucketDay: 'Day',
    uuidError: 'Could not resolve station UUID. Please reload the page.',
    loadErrorPrefix: 'Failed to load trend data:',
    unknownError: 'Unknown error',
    loadDataError: 'Failed to load data:',
    noDataForPeriod: 'No data for the selected period',
    resetZoom: 'Reset zoom',
    wheelHint: 'Mouse wheel to zoom; drag to pan',
    fabSettingsAria: 'Settings',
    stationTitle: (stationId) => `Station ${stationId}`,
    docTitle: (stationId) => `Trends · station ${stationId}`,
  },
};

const TIME_RANGE_PAGE = {
  uk: {
    periodTitle: 'Період',
    startDate: 'Дата початку',
    endDate: 'Дата закінчення',
    startTime: 'Час початку',
    endTime: 'Час закінчення',
    back: 'Назад',
    today: 'Сьогодні',
    forward: 'Уперед',
    periodDays: (n) => `Період: ${n} дн.`,
    periodDuration: ({ days, hours, minutes }) => {
      const parts = [];
      if (days) parts.push(`${days} дн.`);
      if (hours) parts.push(`${hours} год.`);
      if (minutes || parts.length === 0) parts.push(`${minutes} хв.`);
      return `Період: ${parts.join(' ')}`;
    },
    weekDaysMonFirst: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'],
    dateLocale: 'uk-UA',
  },
  en: {
    periodTitle: 'Period',
    startDate: 'Start date',
    endDate: 'End date',
    startTime: 'Start time',
    endTime: 'End time',
    back: 'Back',
    today: 'Today',
    forward: 'Forward',
    periodDays: (n) => `Period: ${n} day${n === 1 ? '' : 's'}`,
    periodDuration: ({ days, hours, minutes }) => {
      const parts = [];
      if (days) parts.push(`${days} day${days === 1 ? '' : 's'}`);
      if (hours) parts.push(`${hours} hour${hours === 1 ? '' : 's'}`);
      if (minutes || parts.length === 0) {
        parts.push(`${minutes} minute${minutes === 1 ? '' : 's'}`);
      }
      return `Period: ${parts.join(' ')}`;
    },
    weekDaysMonFirst: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    dateLocale: 'en-US',
  },
};

const ALARMS_PAGE = {
  uk: {
    scopeSourceTitle: 'Об’єкт / джерело (URL: uid, station, projectOnly, sourceType)',
    uidRouteDefault: '(як у станції в маршруті)',
    projectAllEvents: 'Проєкт (усі project-події)',
    stationNumLabel: '№ ст.',
    sourceTypeLabel: 'source_type',
    all: 'Усі',
    projectEventsOnly: 'Лише проєктні події (project_tag)',
    applyObjectFilter: 'Застосувати фільтр об’єкта',
    eventType: 'Тип події',
    filterAllTypes: 'Усі типи',
    filterAlarms: 'Аварії',
    filterWarnings: 'Попередження',
    filterUserActions: 'Дії користувача',
    searchPlaceholder: 'Пошук за текстом повідомлення…',
    resetShort: 'Скинути',
    clear: 'Очистити',
    apply: 'Застосувати',
    refresh: 'Оновити',
    filtersDrawerTitle: 'Фільтри й налаштування',
    contextProject: 'Поточний контекст: проєктні події',
    contextApplied: (uid, station) => `Застосовано: UID ${uid}, станція ${station}`,
    emDash: '—',
    tableStart: 'Початок',
    tableEnd: 'Кінець',
    tableType: 'Тип',
    tableSchema: (name) => ` (схема: ${name})`,
    tableMessage: 'Повідомлення',
    tableUser: 'Користувач',
    tableState: 'Стан',
    active: 'Активна',
    instant: 'МИТТЄВО',
    stateActive: 'АКТИВНА',
    stateReset: 'КВИТОВАНО',
    mobileReset: 'КВИТОВАНО',
    mobileActive: 'АКТИВНА',
    emptyTitle: 'Немає подій',
    emptyBody:
      'За обраний період подій не знайдено. Спробуйте змінити фільтри або період часу.',
    emptyHintFilters: 'Підказка: скористайтеся кнопкою фільтрів нижче',
    emptyHintReload: 'Або спробуйте оновити сторінку',
    emptyAlert: 'Немає подій за обраний період',
    loadMore: 'Показати ще 100',
    loadingMore: 'Завантаження…',
    fabFiltersAria: 'Фільтри',
    sevAlarm: 'АВАРІЯ',
    sevWarning: 'ПОПЕРЕДЖЕННЯ',
    sevAction: 'ДІЯ',
    mobileStart: 'Початок:',
    mobileEnd: 'Кінець:',
    mobileUser: 'Користувач:',
    stationTitle: (stationId) => `Станція ${stationId}`,
    docTitle: (stationId) => `Аварії · станція ${stationId}`,
  },
  en: {
    scopeSourceTitle: 'Object / source (URL: uid, station, projectOnly, sourceType)',
    uidRouteDefault: '(same as station in route)',
    projectAllEvents: 'Project (all project events)',
    stationNumLabel: 'St. №',
    sourceTypeLabel: 'source_type',
    all: 'All',
    projectEventsOnly: 'Project events only (project_tag)',
    applyObjectFilter: 'Apply object filter',
    eventType: 'Event type',
    filterAllTypes: 'All types',
    filterAlarms: 'Alarms',
    filterWarnings: 'Warnings',
    filterUserActions: 'User actions',
    searchPlaceholder: 'Search in message text…',
    resetShort: 'Reset',
    clear: 'Clear',
    apply: 'Apply',
    refresh: 'Refresh',
    filtersDrawerTitle: 'Filters & settings',
    contextProject: 'Current context: project events',
    contextApplied: (uid, station) => `Applied: UID ${uid}, station ${station}`,
    emDash: '—',
    tableStart: 'Start',
    tableEnd: 'End',
    tableType: 'Type',
    tableSchema: (name) => ` (schema: ${name})`,
    tableMessage: 'Message',
    tableUser: 'User',
    tableState: 'State',
    active: 'Active',
    instant: 'INSTANT',
    stateActive: 'ACTIVE',
    stateReset: 'ACKNOWLEDGED',
    mobileReset: 'ACKNOWLEDGED',
    mobileActive: 'ACTIVE',
    emptyTitle: 'No events',
    emptyBody: 'No events in the selected period. Try changing filters or the time range.',
    emptyHintFilters: 'Tip: use the filters button below',
    emptyHintReload: 'Or try refreshing the page',
    emptyAlert: 'No events for the selected period',
    loadMore: 'Load 100 more',
    loadingMore: 'Loading…',
    fabFiltersAria: 'Filters',
    sevAlarm: 'ALARM',
    sevWarning: 'WARNING',
    sevAction: 'ACTION',
    mobileStart: 'Start:',
    mobileEnd: 'End:',
    mobileUser: 'User:',
    stationTitle: (stationId) => `Station ${stationId}`,
    docTitle: (stationId) => `Alarms · station ${stationId}`,
  },
};
